/* RESPONSIBLE TEAM: team-ai-insights */
import TopicsExplorer from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/topics-explorer';

export default class FinStandaloneTopicsExplorer extends TopicsExplorer {
  analytics = {
    section: 'standalone',
    place: 'topics-explorer',
  };

  templateName = 'apps/app/automation/fin-ai-agent/analyze/topics-explorer';
  routeWhenNotOptedIn = 'apps.app.standalone.setup';
}
